export default __webpack_public_path__ + "static/media/PeeCeeATRNew1.8f95408a.png";